import { Button, Col, Icon, Row, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import './InvestigacionCdi.scss'
import {getCdiDataPromise, getVinculosPromise, getMatchesPromise} from './promises'
import moment from 'moment';
import { camelizerHelper } from '../../../../../../helpers';

const InvestigacionCdi = ({itemTable, forceExpand}) => {
    const { t } = useTranslation();
    const [seeMore, setSeeMore] = useState(forceExpand);
    const [seeMore1, setSeeMore1] = useState(forceExpand);
    const [recordsFilteredByMatch, setRecordsFilteredByMatch] = useState([]);
    const [relatedByMatch, setRelatedByMatch] = useState([]);

    useEffect(() => {
        getCdiDataPromise(itemTable.id).then(response => {
            let tmpRecords = response?.records?.filter(element => element.type ==='M')
            setRecordsFilteredByMatch(tmpRecords)

            let tmpRelated = response?.related
            setRelatedByMatch(tmpRelated)
        })
    }, []);

    const investigationRequestsColumns = [
        {
            title: t("messages.aml.folio"),
            dataIndex: 'folio'
        },
        {
            title: t("messages.aml.request"),
            dataIndex: "requestDate",
            render: text => moment(text).format('DD/MM/YYYY')
        },
        {
            title: t("messages.aml.status"),
            dataIndex: "status",
            render: text => t("messages.aml.cdi.status."+text)
        },
        {
            title: t("messages.aml.statusDate"),
            dataIndex: 'creationDate',
            render: text => moment(text).format('DD/MM/YYYY')
        },
        {
            title: t("messages.aml.links"),
            align: 'center',
            dataIndex: 'hasPositives',
            render: text => text ? t("messages.aml.yes") : t("messages.aml.no")
        }
    ]

    const relatedColumns = [
        {
            title: t("messages.aml.personType"),
            dataIndex: 'type',
            render: (text) => t("messages.aml."+text.toLowerCase())
        },
        {
            title: t("messages.aml.category"),
            dataIndex: "category",
            render: text => camelizerHelper(text)
        },
        {
            title: t("messages.aml.name"),
            dataIndex: "nombre",
            render: text => camelizerHelper(text)
        },
        {
            title: t("messages.aml.rut"),
            dataIndex: 'rut'
        },
        {
            title: t("messages.aml.relation"),
            dataIndex: 'related',
        }
    ]

    
  return (
        <div className='investigacion-cdi-main-wrapper'>
            <Row>
                <Col span={22}>
                    <h3>{t("messages.aml.linkIdentificationRequests")}</h3>
                </Col>
                <Col span={2} style={{textAlign:'right'}}>
                    <Button type="link" onClick={() => {setSeeMore(!seeMore)}}>
                        {seeMore ?
                        <>{t("messages.aml.seeLess")} <Icon type="minus"/></>
                        :
                        <>{t("messages.aml.seeMore")} <Icon type="plus"/></>
                        }
                    </Button>
                </Col>
            </Row>
            <hr/>
            {seeMore &&
                <div className="modal-risk-main-wrapper">
                    <Row className="field-section-row">
                        <Col span={3}>
                            <div className="info-yellow-card-cdi">
                            {t("messages.aml.requests")} <br/>
                            {recordsFilteredByMatch?.length}
                            </div>
                        </Col>
                        <Col span={3}>
                            <div className="info-yellow-card-cdi">
                            {t("messages.aml.pending")} <br/>
                                {recordsFilteredByMatch?.filter(item => item.status === 'PENDING').length}
                            </div>
                        </Col>
                        <Col span={3}>
                            <div className="info-yellow-card-cdi">
                            {t("messages.aml.completed")} <br/>
                                {recordsFilteredByMatch?.filter(item => item.status === 'FINISHED').length}
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={[0,20]}>
                        <Col span={24}>
                            <Table dataSource={recordsFilteredByMatch} columns={investigationRequestsColumns} pagination={!forceExpand && recordsFilteredByMatch?.length > 10}/>
                        </Col>
                    </Row>
                    <>
                    
                    </>
                </div>
            }
          
                {/* <>
                    <Row>
                        <Col span={22}>
                            <h3>Identificación entre partes</h3>
                        </Col>
                        <Col span={2} style={{textAlign:'right'}}>
                            <Button type="link" onClick={() => {setSeeMore1(!seeMore1)}}>
                                {seeMore1 ?
                                <>Ver menos <Icon type="minus"/></>
                                :
                                <>Ver más <Icon type="plus"/></>
                                }
                            </Button>
                        </Col>
                    </Row>
                    <hr/>
                    {seeMore1 &&
                        <div className="modal-risk-main-wrapper">
                            <Row gutter={[0,20]}>
                                <Col span={15}>
                                    <Table dataSource={relatedByMatch} columns={relatedColumns} pagination={!forceExpand && relatedByMatch?.length > 10}/>
                                </Col>
                            </Row>
                        </div>
                    }
                </> */}
            
        </div>
  )
}

export default InvestigacionCdi;